/**
 * Created by amirb on 1/29/15.
 */
define(function (require) {

    var VisitInfoBase = require('web-agent-widgets/VisitInfoBase');

    var EngagementsHistoryVisitInfoWidget = VisitInfoBase.extend({
        ControllerName: "EngagementsHistoryVisitInfoWidget",
        applicationType: "EngagementsHistoryVisitInfoWidget",

        LPViewMap: {
        },

        initialize: function (constructorData) {
        },

        events: function () {
        },

        render: function () {
        }
    });

    EngagementsHistoryVisitInfoWidget.prototype.getConfiguration = function () {
        var configuration = {
            useDataInPath: true
        };
        return configuration;
    };

    EngagementsHistoryVisitInfoWidget.prototype.showOrHideWidget = function (data) {
        this.hidden = (!data || !data.length);
        this.showWidget();
    };

    return EngagementsHistoryVisitInfoWidget;

});
